(function () {
  var supportsCache = 'caches' in window;
  var CACHE_NAME = 'hs-academy';
  const LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];

  function makeEarlyRequest(requestName, endpoint, options) {
    options = options || {};

    if (isIe11) {
      endpoint +=
        '?ie11cacheBust=' +
        Math.round(Math.random() * 9999999999999).toString();
    }

    var url = window.quickFetch.getApiUrl(endpoint, true);

    window.quickFetch.makeEarlyRequest(requestName, {
      url: url,
      dataType: 'json',
      contentType: 'application/json',
      type: options.method || 'GET',
      data: options.data,
      noPortalId: !!options.noPortalId,
    });
    if (supportsCache && options.useCacheStorage) {
      window.hubspot.academy = window.hubspot.academy || {};
      window.hubspot.academy.fromCacheStorage =
        window.hubspot.academy.fromCacheStorage || {};

      caches.open(CACHE_NAME).then(function (cache) {
        var earlyRequest = window.quickFetch.getRequestStateByName(requestName);
        if (earlyRequest) {
          earlyRequest.whenFinished(function (result) {
            var data = JSON.stringify(result);

            // Save the response in the cache
            cache.put(
              url,
              new Response(data, {
                status: 200,
                headers: new Headers({
                  'Content-Type': 'application/json;charset=utf-8',
                  'Content-Length': data.length,
                  Date: new Date().toUTCString(),
                }),
              })
            );
          });

          // Check if there's a previously saved response in the cache
          cache.match(url).then(function (cachedResponse) {
            if (cachedResponse && cachedResponse.ok) {
              cachedResponse.json().then(function (json) {
                window.hubspot.academy.fromCacheStorage[endpoint] = {
                  result: json,
                  timestamp: Date.parse(cachedResponse.headers.get('Date')),
                };
              });
            }
          });
        }
      });
    }
  }

  function fetchIndividual(parts) {
    var endpoint = parts.join('/');

    makeEarlyRequest(endpoint, endpoint);
  }

  var isIe11 = false;
  try {
    isIe11 = window.navigator.userAgent.indexOf('Trident/7.0') > -1;
  } catch (e) {}

  var lang = 'en';
  var langParam = '';
  try {
    lang =
      JSON.parse(
        localStorage.getItem('i18n-cached-standard-locales') || '[]'
      )[0] || lang;
    lang = lang.split('-')[0];
    langParam = (location.search.split('language=')[1] || '').split('&')[0];
    if (!LANGUAGES.includes(lang.toUpperCase())) {
      lang = 'en';
    }
    if (!LANGUAGES.includes(langParam.toUpperCase())) {
      langParam = '';
    }
  } catch (error) {
    console.warn(error);
  }

  makeEarlyRequest(
    'cross-hublet-accounts',
    '/accounts/v1/accounts/cross-hublet',
    { noPortalId: true }
  );
  makeEarlyRequest('user-info', '/login-verify/user-info', {
    noPortalId: true,
  });

  const portalId = window.quickFetch.getPortalId();

  if (portalId) {
    makeEarlyRequest('api-verify', '/login-verify/hub-user-info');

    var pathname = window.location.pathname;
    var trackIdMatches, lessonIdMatches;
    if (
      pathname.match(/\d+(\/)?$/i) /*homepage*/ ||
      pathname.match(/results|favorites(\/?)$/i) ||
      pathname.match(/my-learning/i)
    ) {
      makeEarlyRequest(
        'tracks-' + lang,
        '/academy-catalog/v2/tracks/' + lang + '?fallbackLanguage=en',
        { useCacheStorage: true }
      );
      makeEarlyRequest(
        'lessons-' + lang,
        '/academy-catalog/v1/lessons/' + lang + '?fallbackLanguage=en',
        { useCacheStorage: true }
      );
    }
    if (pathname.match(/partners/i)) {
      makeEarlyRequest(
        'partner-tracks-' + lang,
        '/academy-catalog/v1/tracks/partners/' + lang + '?fallbackLanguage=en',
        { useCacheStorage: true }
      );
      makeEarlyRequest(
        'partner-lessons-' + lang,
        '/academy-catalog/v1/lessons/partners/' + lang + '?fallbackLanguage=en',
        { useCacheStorage: true }
      );
    }
    // at least 1 id should be present for individual fetch
    else if (
      (trackIdMatches =
        pathname.match(/tracks\/(\d+)/) || pathname.match(/course\/(\d+)/))
    ) {
      fetchIndividual([
        '/academy-catalog/v1/tracks',
        trackIdMatches[1],
        langParam || lang,
      ]);
    } else if ((lessonIdMatches = pathname.match(/lessons\/(\d+)/))) {
      fetchIndividual([
        '/academy-catalog/v1/lessons',
        lessonIdMatches[1],
        langParam || lang,
      ]);
    }

    makeEarlyRequest('academy-filters', '/academy-catalog/v1/filters');

    window.quickFetch.afterAuth((authData) => {
      const toggleGlobalNav = () => {
        const isMobile = window.matchMedia('(max-width: 544px)').matches;

        const hideNavStyleElement =
          document.getElementById('hs-nav-hide-style');

        if (!hideNavStyleElement) {
          return;
        }

        if (isMobile) {
          hideNavStyleElement.disabled = false;
        } else {
          hideNavStyleElement.disabled = true;
        }
      };

      toggleGlobalNav();

      window.addEventListener('resize', toggleGlobalNav);

      const hasPartnerGate = authData.portal.enabled_gates.includes(
        'AcademyCertification:ForcePartnerCertification'
      );
      const hasPartnerScope =
        authData.user.scopes.includes('partner-certifications') ||
        (authData.user.scopes.includes('academy-partner-training-access') &&
          authData.user.scopes.includes('partner-paywall-hide'));

      const isPartner = hasPartnerGate || hasPartnerScope;

      if (
        (isPartner && pathname.match(/\d+(\/)?$/i)) /*homepage*/ ||
        pathname.match(/results|favorites(\/?)$/i) ||
        pathname.match(/my-learning/i)
      ) {
        makeEarlyRequest(
          'partner-tracks-' + lang,
          '/academy-catalog/v1/tracks/partners/' +
            lang +
            '?fallbackLanguage=en',
          { useCacheStorage: true }
        );
        makeEarlyRequest(
          'partner-lessons-' + lang,
          '/academy-catalog/v1/lessons/partners/' +
            lang +
            '?fallbackLanguage=en',
          { useCacheStorage: true }
        );
      }
    });
  }
})();
